export default "__VITE_ASSET__Dp6OA0x8__"